import { render } from "./Tipos_estatus.vue?vue&type=template&id=ccf657e4&scoped=true"
import script from "./Tipos_estatus.vue?vue&type=script&lang=js"
export * from "./Tipos_estatus.vue?vue&type=script&lang=js"

import "./Tipos_estatus.vue?vue&type=style&index=0&id=ccf657e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Josue\\Documents\\IMSS\\CDI\\SITE\\frontrdsyuc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccf657e4"]])

export default __exports__